module.exports = __webpack_public_path__ + "img/services-alb - Copy.a6bd3f30.svg";